import { Box, BoxProps, Button, ButtonProps, styled } from '@mui/material'
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome'

export const AnswerMaskButton = styled(Button)<ButtonProps>(({ theme }) => ({
  padding: theme.spacing(4),
  minWidth: '54px',
  backgroundColor: theme.palette.grey[50],
  borderRadius: `0px ${theme.shape.borderRadius * 1.5}px ${theme.shape.borderRadius * 1.5}px 0px`,
  transition: 'none',

  '&:hover': {
    backgroundColor: theme.palette.grey[100],
  },
  '&:active': {
    backgroundColor: theme.palette.grey[200],
  },

  '& svg': {
    fontSize: '1.125rem',
  },

  [theme.breakpoints.down('mobile')]: {
    minWidth: '41px',
    padding: theme.spacing(2.25),
  },
}))

export const AnswerMaskIcon = styled(FontAwesomeIcon)<FontAwesomeIconProps>(({ theme: { palette } }) => ({
  color: palette.grey[800],
}))

export const AnswerMaskOverlay = styled(Box)<BoxProps>(({ theme }) => ({
  position: 'absolute',
  top: '0px',
  left: '0px',
  width: '100%',
  height: '100%',
  zIndex: 100,
  backgroundColor: theme.palette.grey[100],
}))